import { Component, effect, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';
import { SingleDropdownComponent } from 'app/shared/components/dropdowns/single-dropdown/single-dropdown.component';
import { InputFieldComponent } from 'app/shared/components/input-field/input-field.component';
import {
	numberCast,
	toDateString,
} from 'app/shared/functions/sectionCasters.function';
import { VehicleModelsFilters } from '@splitsecondconnect/ultramarine-shared';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { DatetimePickerComponent } from '../../../../../../shared/components/datetime-picker/datetime-picker.component';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';
import { VEHICLE_BODY_TYPE } from '../../../translations/vehicles-select-items';

import { MakeSaerchableComponent } from './components/make-searchable.component';
import { ModelSaerchableComponent } from './components/model-searchable.component';

@Component({
	selector: 'app-vehicles-make-model',
	templateUrl: 'vehicles-make-model.component.html',
	imports: [
		ReactiveFormsModule,
		InputFieldComponent,
		SingleDropdownComponent,
		SectionWrapperComponent,
		DatetimePickerComponent,
		MakeSaerchableComponent,
		ModelSaerchableComponent,
	],
})
export class VehiclesMakeModelComponent extends BaseSectionComponent<VehicleRecordModel> {
	protected _skipCount: number = 0;
	bodyType = VEHICLE_BODY_TYPE;
	modelFilters = signal<VehicleModelsFilters>({ makes: [] });
	showModel = signal(false);

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			year: [null],
			series: [null],
			trim: [null],
			manufacturedAt: [null],
			bodyType: [null],
			makeId: [null],
			modelId: [null],
		});

		effect(() => {
			if (!this.showModel()) {
				this.detailsForm.get('modelId')?.setValue(null);
			}
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			year: this.recordData().year,
			series: this.recordData().series,
			trim: this.recordData().trim,
			manufacturedAt: toDateString(this.recordData().manufacturedAt),
			bodyType: this.recordData().bodyType,
			makeId: this.recordData().makeId,
			modelId: this.recordData().modelId,
		};
		this.showModel.set(!!this.recordData().makeId);
		this.modelFilters.set({
			makes: [this.recordData().makeId],
		});
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<VehicleRecordModel> {
		this.showModel.set(!!this.detailsForm.value.makeId);
		this.modelFilters.set({
			makes: [this.detailsForm.value.makeId],
		});
		return {
			makeId: this.detailsForm.value.makeId,
			modelId: this.detailsForm.value.modelId,
			year: numberCast(this.detailsForm.value.year),
			series: this.detailsForm.value.series,
			trim: this.detailsForm.value.trim,
			manufacturedAt: this.detailsForm.value.manufacturedAt,
			bodyType: this.detailsForm.value.bodyType,
		};
	}
}
